export default __webpack_public_path__ + "static/media/Bg-lateral.ee2d3163.jpg";